import {useAsyncRetry} from 'react-use';
import {UsersService} from '../api/generated';

export const useCurrentUser = () => {
  return useAsyncRetry(async () => {
    const response = await UsersService.getCurrentUser();
    return response.data;
  });
};
